import type { TFunction } from 'i18next';

import { format, formatIntToPrice } from 'utils/price';

import type { PriceType } from '@Modules/offers/types';
import type { QualifiersEnum } from '@Modules/qualifiers/constants';
import type { QualifiersType } from '@Modules/qualifiers/types';

const MIN_PRICE_ALLOWED = 100_000_00;
const MAX_PRICE_ALLOWED = 100_000_000_00;
const MULTIPLIER = 0.09455959662;

export const checkLoanAvailability = (
  price: PriceType | undefined,
  otpMicroloanLink: QualifiersType['qualifiers'][QualifiersEnum.otpMicroloanLink] | undefined,
  business: boolean | undefined
) => {
  if (!price || !otpMicroloanLink || business) {
    return false;
  }

  return price.value >= MIN_PRICE_ALLOWED || price.value <= MAX_PRICE_ALLOWED;
};

export const getMonthlyLoanPayment = (price: PriceType, t: TFunction<'translation', undefined>) =>
  format(formatIntToPrice(Math.ceil(price.value * MULTIPLIER)), price.currency, t);
